import React, { useState, useRef } from "react";
import { FixedSizeList as List } from 'react-window';
import Lightbox from './Lightbox';
import { useSwipeable } from 'react-swipeable';

const Pages = ({ issue, count, pages, start, path, paywall, nextSlide, prevSlide }) =>  {
  
  const sliderRef = useRef(null);
  const issuePages = JSON.parse(pages);
  const [lightboxIndex, setLightboxIndex] = useState();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  
  const handlers = useSwipeable({
    onSwipedLeft: () => nextSlide(),
    onSwipedRight: () => prevSlide(),
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  }

  const closeLightbox = () => {
    setLightboxOpen(false);
  }

  const changeLightboxIndex = (index) => {
    if(index > 0 && index <= count ) {
      setLightboxIndex(index);
    }
  }

  const Column = ({ index, style }) => issuePages[index] && 'page_number' in issuePages[index] && (
    <div data-index={ issuePages[index].page_number } className="issue-slider__item" style={style}>
        { issuePages[index].page_number === start ? (
          <span className="issue-slider__current">Current Page</span>
        ) : null}

        <div onClick={() => openLightbox(issuePages[index].page_number)} className={`issue-slider__page${issuePages[index].page_number === start ? ' issue-slider__page--current' : ''}`}>
          <img draggable="false" className="issue-slider__image" src={`//media.motorsportmagazine.com/${ path }/${ issue }/180px/${ issuePages[index].page_number}.jpg`}
            srcSet={`//media.motorsportmagazine.com/${ path }/${ issue }/180px/${ issuePages[index].page_number}.jpg 180w,
                  //media.motorsportmagazine.com/${ path }/${ issue }/300px/${ issuePages[index].page_number}.jpg 300w`}
                  data-title={`Page number ${issue}  - ${ issuePages[index].page_number}`} alt={`${issue} - Page ${issuePages[index].page_number}`}
                  width="200" height="264"
              />
        </div>

        <span className="issue-slider__page-number">{ issuePages[index].page_number}</span>
    </div>
  );

  return (

    <>
      <div className="issue-slider__list-wrapper" {...handlers}>
        <List
          className="issue-slider__list"
          height={220}
          itemCount={parseInt(count)}
          itemSize={140}
          layout="horizontal"
          width={800}
          ref={sliderRef}
        >
          {Column}
        </List>
      </div>

      <Lightbox id={issuePages[lightboxIndex] ? issuePages[lightboxIndex].ID : null } open={lightboxOpen} path={path} pages={issuePages} index={lightboxIndex} issue={issue} total={issuePages.length} paywall={paywall} closeLightbox={closeLightbox} changeIndex={changeLightboxIndex} />

    </>

  )

};

export default React.memo(Pages);